var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.5L8.25 3L3.75 7.5",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.5V15.75C18.75 17.1424 18.1969 18.4777 17.2123 19.4623C16.2277 20.4469 14.8924 21 13.5 21H13.5C12.8106 21 12.1279 20.8642 11.4909 20.6004C10.8539 20.3365 10.2752 19.9498 9.78769 19.4623C9.30018 18.9748 8.91347 18.3961 8.64963 17.7591C8.38579 17.1221 8.25 16.4394 8.25 15.75V3",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftUp);
export default __webpack_public_path__ + "static/media/arrow-left-up.a02f4e921de2b24cf967161ceda30bc0.svg";
export { ForwardRef as ReactComponent };